import { motion } from "framer-motion";
import { useState } from "react";
import apiendspoint from "../apiendpoint.json";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import { toast, ToastContainer } from "react-toastify";

export default function Form() {
  const [isname, setName] = useState("");
  const [isPhone, setPhone] = useState("");
  const [isEmail, setEmail] = useState("");
  const [isMessage, setMessage] = useState("");
  const [isloading, setLoading] = useState(false);
  const [isEmailError, setEmailError] = useState("");
  const [isPhoneError, setPhoneError] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const recaptchaRef = useRef(null);

  const emailValidation = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneValidation = /^(?:\+?\d{1,3}[ -]?)?(?:\d{3,5}[- ]?)?\d{10}$/;

  const validate = () => {
    let valid = true;
    if (!emailValidation.test(isEmail)) {
      setEmailError("invalid Email");
      valid = false;
    } else {
      setEmailError("");
    }
    if (!phoneValidation.test(isPhone)) {
      setPhoneError("phone number are invalid");
      valid = false;
    } else {
      setPhoneError("");
    }
    if (!recaptchaToken) {
      toast.error("Please complete the reCAPTCHA");
      valid = false;
    }
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const payload = {
      NameUser: isname,
      Email: isEmail,
      Message: isMessage,
      mobile: isPhone,
      recaptchaToken,
    };

    try {
      const response = await fetch(`${apiendspoint.enquiryUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          entity: "enquiry",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Form submission failed");
      }

      toast.success("Form submitted successfully!");
      setEmail("");
      setMessage("");
      setName("");
      setPhone("");
      setRecaptchaToken("");
      recaptchaRef.current.reset();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex w-full items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white p-6 rounded-xl max-w-md w-full text-[#1F2937] border border-[#c8e8b8]"
      >

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#0e4322] mb-1">Full Name</label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-[#c8e8b8] rounded-lg focus:ring-2 focus:ring-[#a8d490] focus:border-[#a8d490] outline-none transition-all bg-white"
              placeholder="Enter your name"
              value={isname}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-[#0e4322] mb-1">Phone Number</label>
            <input
              type="tel"
              className="w-full px-4 py-2 border border-[#c8e8b8] rounded-lg focus:ring-2 focus:ring-[#a8d490] focus:border-[#a8d490] outline-none transition-all bg-white"
              placeholder="Enter your phone number"
              value={isPhone}
              onChange={(e) => setPhone(e.target.value)}
            />
            {isPhoneError && (
              <p className="text-red-600 text-xs mt-1">{isPhoneError}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-[#0e4322] mb-1">Email</label>
            <input
              type="email"
              className="w-full px-4 py-2 border border-[#c8e8b8] rounded-lg focus:ring-2 focus:ring-[#a8d490] focus:border-[#a8d490] outline-none transition-all bg-white"
              placeholder="Enter your email"
              value={isEmail}
              onChange={(e) => setEmail(e.target.value)}
            />
            {isEmailError && (
              <p className="text-red-600 text-xs mt-1">{isEmailError}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-[#0e4322] mb-1">Message</label>
            <textarea
              className="w-full px-4 py-2 border border-[#c8e8b8] rounded-lg focus:ring-2 focus:ring-[#a8d490] focus:border-[#a8d490] outline-none transition-all bg-white"
              placeholder="Enter your message"
              rows="4"
              value={isMessage}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>

          {/* Google reCAPTCHA */}
          <div className="pt-2 flex justify-center md:justify-start">
            <div className="scale-[0.75] md:scale-100 origin-center">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => setRecaptchaToken(token)}
              />
            </div>
          </div>

          <button
            type="submit"
            className={`mt-4 w-full py-3 rounded-lg font-medium transition-all ${isloading
                ? 'bg-[#c8e8b8] cursor-not-allowed'
                : 'bg-green-600 text-white hover:bg-green-700'
              }`}
            disabled={isloading}
          >
            {isloading ? (
              <span className="flex items-center justify-center">
                Processing...
              </span>
            ) : 'Submit'}
          </button>
        </form>
      </motion.div>

      <ToastContainer
        autoClose={3000}
        limit={2}
        hideProgressBar={true}
        className="z-[9999] fixed top-28"
      />
    </div>
  );
}
